<template>
    <div class="echart-talbe">
        <el-table
            ref='tableList'
            :header-cell-style="{background:'#a7754f',color:'#fff'}"
            size='mini'
            :data="echartList"
            border>
            <el-table-column
                label="NO"
                sortable
                align="center"
                width="70"
                prop="num"
            >
            </el-table-column>
            <el-table-column
                align="center"
                prop="keyName"
                label="中药">
            </el-table-column>
            <el-table-column
                align="center"
                sortable
                :sort-method="(a,b) => sortMethod(a ,b , 'valueName')"
                prop="valueName"
                label="频次">
            </el-table-column>
            <el-table-column
                align="center"
                sortable
                :sort-method="(a,b) => sortMethod(a ,b , 'percentage')"
                prop="percentage"
                label="百分比">
            </el-table-column>
            <el-table-column
                align="center"
                sortable
                :sort-method="(a,b) => sortMethod(a ,b , 'aveValue')"
                label="平均剂量">
                <template scope="scope">
                   <p> {{ scope.row.aveValue?scope.row.aveValue:0  }}</p>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                sortable
                prop="minValue"
                :sort-method="(a,b) => sortMethod(a ,b , 'minValue')"
                label="最小剂量">
            </el-table-column>
            <el-table-column
                align="center"
                sortable
                :sort-method="(a,b) => sortMethod(a ,b , 'maxValue')"
                prop="maxValue"
                label="最大剂量">
            </el-table-column>
            <el-table-column
                align="center"
                sortable
                width="90"
                prop="f1"
                :sort-method="(a,b) => sortMethod(a ,b , 'f1')"
                label="标准差">
            </el-table-column>
            <el-table-column
                v-if="chartType=='formulaComposition'"
                align="center"
                prop="address"
                label="操作">
                <template slot-scope="scope">
                    <el-button @click='dose_click(scope.row)' type="text">剂量分析</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if='isShowDose'>
            <doseModel :show.sync='isShowDose' :doseName="doseName" :doseInfo="doseInfo"></doseModel>
        </div>
        
    </div>
</template>

<script>

// 剂量分析图
import doseModel from './dose_model.vue'
import {mapState,mapMutations,mapActions} from 'vuex'
export default {
    components: {
        doseModel
    },
    data () {
        return {
            tableData:[],
            isShowDose:false,
            doseName:'',

            doseInfo:{},
        }
    },
    computed: {
        ...mapState({
            chartName:state=>state.excavate.chartName,
            echartList:state=>state.excavate.echartList,
            chartType:state=>state.excavate.chartType,
        })
    },
    mounted () {
        this.getInfo()
    },
    methods: {
        className(){
            return "talbe-bg";
        },
        dose_click(row){
            this.isShowDose = true;
            this.doseName = row.keyName;
            this.doseInfo = row;
        },
        
        sortMethod(before, after,column) {
            return Number(before[column]) - Number(after[column]);
        },
         // 恢复默认排序
        clearSort(){
            this.$refs.tableList.clearSort();
        },
        getInfo(){
            // let tableData = this.echartData.chartJson;
            // tableData.forEach((item,index) => {
            //     this.$set(item,'num',index+1)
            // });
            // this.tableData =tableData
        }
    }
}
</script>

<style>

</style>